import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import {
  genericError,
  genericSuccess,
  badgeNameError,
  badgeLogoError,
} from '@/utils/alerts.service';
import { createUpdateDelete } from '@/store/vendorDashboard/modules/createUpdateDelete';

export const badges = {
  namespaced: true,
  state: {
    ...createUpdateDelete.state,
  },
  getters: {
    ...createUpdateDelete.getters,
  },
  mutations: {
    ...createUpdateDelete.mutations,

    setBadges(state, data) {
      data.sort((a, b) => {
        return a.order - b.order;
      });
      data.forEach((x, i) => {
        x.order = i;
      });
      state.items = data;
    },
  },
  actions: {
    ...createUpdateDelete.actions,

    addDirtyTab({ commit }) {
      commit('settings/addDirtyTab', 'badges', { root: true });
    },

    async fetchBadges({ dispatch, commit }) {
      return vendorDashboardAPI
        .getBadges()
        .then(data => {
          commit('setBadges', data.results);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async saveBadges({ state, dispatch, commit }) {
      const data = [...state.items, ...state.newItems];

      for (let i of data) {
        if (!i.name) {
          return dispatch(
            'showUserMessage',
            { ...badgeNameError },
            { root: true }
          );
        }
        if (!i.logo) {
          return dispatch(
            'showUserMessage',
            { ...badgeLogoError },
            { root: true }
          );
        }
      }

      return vendorDashboardAPI
        .saveBadges(data)
        .then(res => {
          commit('clearItems');
          commit('setBadges', res.data);
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },
  },
};
